export default "__VITE_ASSET__CsWX0lF5__"